<template>
    <MicroAppCatalogPage disable-lazy-hydration />
</template>

<script setup lang="ts">
import MicroAppCatalogPage from '~/components/micro-app/MicroAppCatalogPage.vue'
</script>
